export const MINIMUM_RADIUS_VALUE_IN_KM = 40
